<script>
 export let cssClass;
</script>

<hr class="my-2 {cssClass}" />